import { identity } from 'lodash';

const availableRoleActions = (vocabularyRoleActions, selectedRoleActions, accessor = identity) => (
  selectedRoleActions.filter((item) => vocabularyRoleActions.some(({ name }) => name === accessor(item)))
);

export default availableRoleActions;
